import React from "react";

interface IconProps {
    color?: string;
    height?: string;
}

const TelegramIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        height={height}
        width={height}
        fill="none"
        stroke={color}
        strokeWidth="3"
    >
        <path
            d="M26.67,38.57l-.82,11.54A2.88,2.88,0,0,0,28.14,49l5.5-5.26,11.42,8.35c2.08,1.17,3.55.56,4.12-1.92l7.49-35.12h0c.66-3.09-1.08-4.33-3.16-3.55l-44,16.85C6.47,29.55,6.54,31.23,9,32l11.26,3.5L45.59,20.71c1.23-.83,2.36-.37,1.44.44Z"
            strokeLinecap="round"
        />
    </svg>
);

export default TelegramIcon;